export interface IGeo {
  regionId: number;
  address: IAddress[];
  undergrounds: IUnderground[];
  coordinates?: ICoordinates;
  title?: IGeoTitle | null;
}

export interface IUnderground {
  fullUrl?: string | null;
  // isDefault: boolean;
  lineColor?: string | null;
  name: string;
  releaseYear?: number | null;
  time?: number | null;
  transportType?: ETransportType | null;
  underConstruction: boolean;
}

export interface ICoordinates {
  lat: number;
  lng: number;
}

export enum ETransportType {
  Transport = 'transport',
  Walk = 'walk',
}

export interface IGeoTitle {
  name?: string | null;
  link?: string | null;
}

export interface IAddress {
  fullUrl?: string | null;
  title?: string | null;
}
